import React, {useEffect, useMemo, useRef, useState} from 'react';
import UButton from "ubs-framework/v2/UButton";
import UModal from "ubs-framework/v2/UModal/NewUModal";
import Validator from "simple-react-validator";
import {useForceUpdate} from "ubs-framework/v2/hooks/useForceUpdate";
import {errorFocus, getKeyValue, getName, getThumbor} from "ubs-framework/v2/common/function";
import {getKeyName, getLabelValue, getLabelValueUserImage} from "ubs-framework/v2/common/function";
import useSocket from "../../../common/hooks/useSocket";
import {sendData} from "../../../../store/actions";
import UTags from "ubs-framework/v2/UTags";
import UAvatar from "ubs-framework/v2/UAvatar";
import * as Icon from "ubs-icons";
import {COLOR, LIMIT} from "ubs-framework/v2/common/constant";
import UNameJobInfo from "ubs-framework/v2/UNameJobInfo";
import UInput from "ubs-framework/v2/UInput";
import AsyncEmployeeSelect from "../../../common/employee-access-select/async-employee-select";
import Select, {components} from "react-select";
import UDatePicker from "ubs-framework/v2/UDatePicker";
import UHoursMinutes from "ubs-framework/v2/UHoursMinutes";
import UCheckBox from "ubs-framework/v2/UCheckBox";
import {INTERVIEW, QUESTIONS_TEMPLATE_TYPE, REMINDER} from "../../../../common/constant";
import Popup from "reactjs-popup";
import RequestEvaluation from "./common/request-evaluation";
import useDebouncedEffect from "use-debounced-effect";
import {useDispatch, useSelector} from "react-redux";
import UPopup from "ubs-framework/v2/UPopup";
import MembersList from "../../../common/list/members";
import Skeleton from "ubs-framework/v2/skeleton";
import UDraftEditor from "../../../common/draft-editor";
import InterviewFormPopup from "../../../common/components/interview-form-popup";
import UTooltip from "ubs-framework/v2/Utooltip";
import { useFieldLabel } from 'ubs-framework/v2/hooks/useCustomFieldConfig';
import { PROFILE_SECTION } from 'ubs-framework/v2/common/constant';
const AddInterview = React.memo((props) => {
    const DISPATCH = useDispatch()
    const forceUpdate = useForceUpdate();
    const editorRef = useRef(null);
    const getLabel = useFieldLabel();
    const validator = useRef(new Validator({
        element: (message) => <>{message}</>,
        autoForceUpdate: { forceUpdate },
        validators: {
            greaterTime: {
                message: 'Please select time greater than current time.',
                rule: (val, params, validator) => new Date(val) > new Date() && params.indexOf(val) === -1,
            },
        }
    }))
    const popupRef = useRef(null);
    const _USERS = useSelector(e => e?.ats?.userObj || {});
    const _S3_BASE_URL = useSelector(e => e.common.S3_BASE_URL);
    const _ITL = useSelector(e => e?.ats?.interviewTypeList.map(i => {
        if(i.slug === 'google-meet') {
            i.isDisabled = !e?.ats?.integration[i.slug]
            return e?.common?.planAccess?.recruit?.googleMeetIntegration?.value ? i : null;
        }
        if (i.slug === 'zoom') {
            i.isDisabled = !e?.ats?.integration[i.slug]
            return e?.common?.planAccess?.recruit?.zoomIntegration?.value ? i : null;
        }
        if (i.slug === 'microsoft-teams') {
            i.isDisabled = !e?.ats?.integration[i.slug]
            return e?.common?.planAccess?.recruit?.teamsIntegration?.value ? i : null;
        }
        return i
    }).filter(Boolean));
    const _ALL = useSelector(e => getKeyValue(e?.hrms?.branchList));
    const _A_JTL = useSelector(e => getKeyValue(e?.hrms?.jobTitleList));
    const P_E = useSelector(e => ({
        create: e?.ats?.uac?.candidates?.modules?.evaluation?.action?.create?.value,
        update: e?.ats?.uac?.candidates?.modules?.evaluation?.action?.update?.value,
        delete: e?.ats?.uac?.candidates?.modules?.evaluation?.action?.delete?.value,
    }));
    const _A_LT = useSelector(e => getLabelValue(e?.hrms?.branchList));

    const [zoomUser, setZoomUser] = useState([]);
    const [loader, setLoader] = useState(false);
    const [loading, setLoading] = useState(true);
    const [requestData, setRequestData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [employeeListOption, setEmployeeListOption] = useState([]);
    const [screeningQuestionsList, setScreeningQuestionsList] = useState([]);
    const [questionnaireList, setQuestionnaireList] = useState([]);
    const [search, setSearch] = useState('');
    const [searchValue, setSearchValue] = useState([]);
    const [stageList, setStageList] = useState([]);
    const [allValues, setAllValues] = useState({
        candidate: null,
        interviewType: "",
        date: new Date(),
        duration: "",
        note: '',
        isCandidateInfoAttached: false,
        email: "",
        contactNumber: "",
        reminderType: 60,
        remindBefore: 10,
        interviewer: [],
        evalution: [],
        isSendEmail: true,
        interviewStage: null,
        questionnairyId: null,
        currentRescheduleNote: '',
        location: null,
        zoomHostEmail: null,
        isSendInterviewForm: false,
        // subject: '',
        // to: [],
        // cc: []
    })
    const [isApplyPopup, setIsApplyPopup] = useState(null);
    const [jobData, setJobData] = useState(null);
    const orgId = window.location.pathname.split('/')[1];
    const applyInterviewURL = `${process.env.REACT_APP_RECRUIT_MODULE_URL}/interview-form/${allValues?.candidate?.value}/${allValues?.candidate?.job}?orgId=${orgId}`;

    const isRescheduleAttempt = useMemo(() => {
        return !!(props?.editData?.rescheduleId);
    }, [props?.editData?.rescheduleId]);

    // On-site: the office address goes into the invite and the calendar event, so location is required
    const isOnSiteInterview = getKeyName(_ITL, allValues?.interviewType)?.type === INTERVIEW.TYPE.ON_SITE;

    const handle = {
        search: (value) => {
            setSearch(value)
            if (value?.length) setIsLoading(true);
        },
        change: (e, name) => {
            setAllValues({...allValues, [name]: e, ...(e === null && name === 'candidate' && {isCandidateInfoAttached: false})});
            if (name === 'zoomHostEmail') {
                setAllValues({...allValues, [name]: e});
            }
            if (name === 'interviewType') {
                delete validator.current.fields['zoomHostEmail']
                delete validator.current.fields['location']
            }
            if(getKeyName(_ITL, e)?.label === 'Zoom') sendData('ats|setting|integration|getZoomUser', {});
        },
        close: e => {
            props?.close()
        },
        scheduleInterview: e => {
            if (!loader && validator?.current?.allValid()) {
                new Date(allValues.date) > new Date()
                setLoader(true)
                const data = {
                    ...allValues,
                    job: allValues?.candidate?.job,
                    candidate: allValues?.candidate?.value,
                    date: new Date(allValues.date).getTime(),
                    remindBefore: Number(allValues.remindBefore) * Number(allValues.reminderType),
                    interviewReminderType: allValues.reminderType === 60 ? 1 : 3600 ? 2 : 86400 ? 3 : 1, /** 1 = minute, 2 = Hours, 3 = Days*/
                    isSendEmail: allValues?.isSendEmail || false,
                    questionnairyId: allValues?.questionnairyId ?? null,
                    isSendInterviewForm: allValues?.isSendInterviewForm

            }
                if(allValues?.isCandidateInfoAttached) data.contactNumber = searchValue?.find(_ => _?._id === allValues?.candidate?._id)?.contactNo
                if(allValues?.isCandidateInfoAttached) data.email = searchValue?.find(_ => _?._id === allValues?.candidate?._id)?.email
                if(allValues?.zoomHostEmail) data.zoomHostEmail = allValues?.zoomHostEmail?.email
                if(allValues?.location) data.location = allValues?.location?.toString()
                if(allValues?.interviewStage) data.interviewStage = allValues?.interviewStage 
                if(allValues?.interviewStage) data.interviewStageName = getKeyName(stageList, allValues?.interviewStage)?.label 
                // data.reminderType
                if (props?.editData?._id) {
                    const evalution = []
                    data?.evalution.forEach(ev => {
                        if (!ev._id) evalution.push(ev)
                    })
                    data.evalution = evalution
                    data._id = props?.editData?._id
                    data.status= 1
                    sendData('ats|interview|update', data)
                    sendData('ats|questionnaire|questionnaireDetails', {candidate: data?.candidate})
                } else if (props?.editData?.rescheduleId) {
                    const existingRescheduleNotes = props?.editData?.rescheduleNote || [];
                    const newRescheduleNote = {
                        note: allValues.currentRescheduleNote,
                        actionAt: new Date().getTime()
                    };
                    const updatedRescheduleNotes = [
                        ...existingRescheduleNotes,
                        newRescheduleNote
                    ];
                    const rescheduleData = {
                        _id: props?.editData?.rescheduleId,
                        status: 5,
                        rescheduleNote: updatedRescheduleNotes,
                        candidate: data?.candidate,
                        job: data?.job,
                        interviewType: data?.interviewType,
                        date: data?.date,
                        duration: data?.duration,
                        remindBefore: data?.remindBefore,
                        note: data?.note,
                        interviewer: data?.interviewer,
                        isCandidateInfoAttached: data?.isCandidateInfoAttached,
                        contactNumber: data?.contactNumber,
                        email: data?.email,
                        isSendEmail: data?.isSendEmail,
                        questionnairyId: data?.questionnairyId,
                        zoomHostEmail: data?.zoomHostEmail,
                        interviewStage: data?.interviewStage,
                        interviewStageName: data?.interviewStageName,
                        location: data?.location,
                        evalution: data?.evalution,
                        reminderType: data?.reminderType,
                        interviewReminderType: data?.interviewReminderType
                    };

                    sendData('ats|interview|update', rescheduleData);
                    sendData('ats|questionnaire|questionnaireDetails', {candidate: data?.candidate})
                } else {
                    sendData('ats|interview|add', data)
                    sendData('ats|questionnaire|questionnaireDetails', {candidate: data?.candidate})
                }
            } else {
                validator?.current?.showMessages();
                setLoader(false)
                errorFocus();
            }
        },
        select: (e, key) => {
            if (popupRef?.current) {
                handle?.change([...allValues?.interviewer, e?.value], key)
                popupRef?.current?.close();
                setTimeout(() => popupRef?.current?.open(), 100)
            }
        },
        remove: (id, key) => {
            setAllValues({...allValues, [key]: allValues?.interviewer?.filter(t => t !== id)});
        },
        addEvaluation: (obj) => {
            const data = JSON.parse(JSON.stringify(allValues?.evalution))
            if (typeof requestData?.index === 'number') {
                data[requestData?.index] = obj
                setAllValues({...allValues, evalution: data});
            } else {
                setAllValues({...allValues, evalution: [...data, obj]});
            }

        },
        editEvaluation: (item, index) => {
            setRequestData({...item, index})
        },
        removeEvaluation: (i) => {
            const data = JSON.parse(JSON.stringify(allValues?.evalution))
            data.splice(i, 1)
            setAllValues({...allValues, evalution: data});
        },
        handleEditorChange : (obj) => {
            let html;
            let parser = new DOMParser();
            let doc = parser.parseFromString(obj.html, 'text/html');

            let aTag = doc.querySelector('a');
            if (aTag) {
                aTag.style.color = 'blue'; // Example inline style
                aTag.style.textDecoration = 'none'; // Remove underline
            }

            html = doc.body.innerHTML;
            const data = {
                note: html,
                rawNote: obj.rawText,
                mentions: obj.mentions
            }
            setAllValues({...allValues, ...data})
        },
        CurrentRescheduleNote: (value) => {
            setAllValues({...allValues, currentRescheduleNote: value});
        }
    }

    const getStatus = useMemo(() => INTERVIEW.STATUS_OPTION.find(e => e?.value === props?.editData?.status), [props?.editData?.status])

    useDebouncedEffect(() => {
        if (search?.length >= LIMIT.SEARCH_CHARACTER) sendData('hrms|dropList|get', {listType: 4, search: search})
        else setEmployeeListOption([]);
    }, LIMIT.DE_BOUNCING_TIME_OUT, [search]);

    const {on, off, refresh} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'ats|interview|add':
                    props?.close()
                    break;
                case 'ats|interview|update':
                    props?.close()
                    break;
                case 'hrms|dropList|get':
                        setEmployeeListOption(getLabelValueUserImage(res?.data?.rows));
                        setIsLoading(false);
                    break
                case 'ats|setting|question-template|list':
                    if (res?.data?.questionTemplateList?.length) {
                        let list = JSON.parse(JSON.stringify(res?.data?.questionTemplateList));
                        list = list?.filter(e => e?.questions?.length)?.map(l => ({...l, label: l?.name, value: l?._id}));
                        if(res?.data?.type === 1) setScreeningQuestionsList(list);
                        if(res?.data?.type === 2) setQuestionnaireList(list)
                    }
                    break
                case 'ats|interview|stage|list': {
    const allStages = res?.data?.response || [];
    const interviewList = res?.data?.interviewList || [];
    const candidateInfo = res?.data?.candidateInfo || null;

    // Update searchValue with candidateInfo if available
    if (candidateInfo) {
        setSearchValue(prev => {
            const filtered = prev.filter(_ => _._id !== candidateInfo._id);
            return [...filtered, candidateInfo];
        });
    }

                    const mainStages = allStages.filter(stage => !stage.parentStage);
                    const groupedStages = mainStages.map(main => {
                        const mainMatch = interviewList.find(
                            i => i?.interviewStage === main?._id && i?.status === 1 && main?.isNextStageLocked
                        );

                        const subStages = allStages.filter(s => s.parentStage === main._id).sort((a, b) => a.sortOrder - b.sortOrder).map(sub => {
                                const subMatch = interviewList.find(
                                    i => i?.interviewStage === sub?._id && i?.status === 1 && sub?.isNextStageLocked
                                );
                                return {
                                    ...sub,
                                    isDisabled: !!subMatch,
                                    label: sub.name,
                                    value: sub._id,
                                    parent: sub.parentStage,
                                    isMain: false,
                                };
                            });
                        return [
                            {
                                ...main,
                                isDisabled: !!mainMatch,
                                label: main.name,
                                value: main._id,
                                parent: null,
                                isMain: true,
                            },
                            ...subStages,
                        ];
                    });

                    const stagesOptions = groupedStages.flat();
                    setStageList(stagesOptions);

                    const findUser = new Set();
                    allStages.forEach(e => {
                        e.evalution?.forEach(ev => {
                            ev.requestFrom?.forEach(r => {
                                if (r.length) findUser.add(r);
                            });
                        });
                    });
                    if (findUser.size !== 0) {
                        DISPATCH({
                            type: 'FIND_MASTER_DATA_LIST',
                            payload: { findUserIdsList: [...findUser] },
                        });
                    }
                    break;
                }

                case 'ats|candidate|search':
                    setSearchValue(res?.data?.list?.map(_ => _))
                    break
                case 'ats|job|fetch':
                    if (res?.data?.jobInfo) {
                        setJobData(res.data.jobInfo);
                    }
                    break
                case 'ats|setting|integration|getZoomUser':
                    setZoomUser(res?.data?.map(l => ({...l, label: l?.display_name, value: l?.email})))
                    setLoading(false)
                    if (props?.editData?.zoomHostEmail) {
                        const emailInfo = res?.data.find(_ => _.email === props?.editData?.zoomHostEmail);
                        setAllValues(prev => ({...prev, ...(props?.editData?.zoomHostEmail && emailInfo && {zoomHostEmail: {...emailInfo, label: emailInfo?.display_name, value: emailInfo?.email}})}));
                    }
                    break
                default:
                    return true;
            }
        } else {
            switch (res.event) {
                case 'ats|interview|add':
                case 'ats|interview|update':
                    setLoader(false)
                    // back to the form so the HR can change the slot after an error
                    setIsApplyPopup(null)
                    break
                default:
                    return true;
            }
        }
    });

    useEffect(() => {
        sendData('ats|setting|question-template|list', {type: QUESTIONS_TEMPLATE_TYPE.EVALUATION_FORM});
        sendData('ats|setting|question-template|list', {type: QUESTIONS_TEMPLATE_TYPE.QUESTIONNAIRES});
    }, [])

    useEffect(() => {
        refresh()
        if (allValues?.candidate?.job) {
            sendData('ats|interview|stage|list', { job: allValues?.candidate?.job, candidate: allValues?.candidate?.value });
            // Fetch job data to check if interview form is enabled
            sendData('ats|job|fetch', { _id: allValues?.candidate?.job });
        }
        return () => off()
    }, [allValues])

    useEffect(() => {
        if (allValues?.interviewStage && !!stageList?.length) {
            const findData = stageList?.find(_ => _?.value === allValues?.interviewStage)
            setAllValues({ ...allValues, evalution: findData.evalution || [], questionnairyId: findData.questionnairyId || null, interviewer: findData.interviewer || [] })
        }
    }, [allValues?.interviewStage])

    useEffect(() => {
        if(props?.editData?.zoomHostEmail) sendData('ats|setting|integration|getZoomUser', {})
    }, [props?.editData?.zoomHostEmail])

    useEffect(() => {
        if (props?.editData) {
            let reminderType = 60
            if (props?.editData?.remindBefore % 60 === 0) reminderType = 60
            if (props?.editData?.remindBefore % 3600 === 0) reminderType = 3600
            if (props?.editData?.remindBefore % 86400 === 0) reminderType = 86400
            let remindBefore = props?.editData?.remindBefore / reminderType

            const data = {
                isSendEmail: props?.editData?.isSendEmail ?? true,
                ...(props?.editData?.candidate && {
                    candidate: {
                        ...props?.editData?.candidate,
                        job: props?.editData?.job,
                        label: getName(props?.editData?.candidate),
                        value: props?.editData?.candidate?._id
                    }
                }),
                ...(props?.editData?.interviewType && {interviewType: props?.editData?.interviewType}),
                ...(props?.editData?.date && {date: props?.editData?.date}),
                ...(props?.editData?.duration && {duration: props?.editData?.duration}),
                ...(props?.editData?.note && {note: editorRef.current.setData(props?.editData?.note || '')}),
                ...(props?.editData?.isCandidateInfoAttached && {isCandidateInfoAttached: props?.editData?.isCandidateInfoAttached}),
                ...(props?.editData?.email && {email: props?.editData?.email}),
                ...(props?.editData?.contactNumber && {contactNumber: props?.editData?.contactNumber}),
                ...(props?.editData?.location && {location: props?.editData?.location}),
                ...(props?.editData?.interviewer && {interviewer: props?.editData?.interviewer}),
                ...(props?.editData?.evalution && {evalution: props?.editData?.evalution}),
                ...(props?.editData?.questionnairyId && {questionnairyId: props?.editData?.questionnairyId}),
                ...(props?.editData?.interviewStage && {interviewStage: props?.editData?.interviewStage}),
                ...(props?.editData?.zoomHostEmail && {zoomHostEmail: props?.editData?.zoomHostEmail}),
                currentRescheduleNote: '',
                ...(props?.editData?.remindBefore && {reminderType, remindBefore}),
            }
            setAllValues({...allValues, ...data})
        }
    }, [props?.editData])

    const handleInterviewFormPopup = () => {
        if (validator.current.allValid()) {
            const isInterviewFormEnabled = jobData?.interviewFormField?.isEnabled !== false;

            // Check both allValues.candidate and the original candidate object from searchValue
            const candidateId = allValues?.candidate?.value || allValues?.candidate?._id || props?.editData?.candidate?._id;
            const candidateFromSearch = searchValue?.find(_ => _._id === candidateId);
            const candidateData = candidateFromSearch || allValues?.candidate || props?.editData?.candidate;
            const hasSubmittedForm = candidateData?.isInterviewFormSubmit || false;

            if (isInterviewFormEnabled && !hasSubmittedForm) {
                setIsApplyPopup(true);
            } else {
                handle.scheduleInterview();
            }
        } else {
            validator.current.showMessages();
            errorFocus();
        }
    };

    return (
        <React.Fragment>
            <UModal
                open={true}
                maxWidth={675}
                position="right"
                className="u_interview-modal"
                onClose={() => props?.close()}
                header={<h4>{(props?.editData && props?.editData?.rescheduleId) ? 'Reschedule' : (props?.editData && props?.editData?._id) ? 'Update' : 'Schedule'} Interview</h4>}
            >
                <div className="u_interviews-form">
                    <div className="u_interviews-form-left">
                        {!!props?.editData && <div className="u_candidate-info u_mb-20">
                            <div className="u_mr-10"><UAvatar width={54} image={props?.editData?.candidate?.profileImage?.url} name={getName(props?.editData?.candidate)} s3Url={_S3_BASE_URL} thumbor={getThumbor()}/></div>
                            <div className="u_candidate-info-inner">
                                <h6 className="u_mb-5">{getName(props?.editData?.candidate)}</h6>
                                <div className="u_flex-align">
                                    <div className="u_flex-align u_pr-10 u_br-light">
                                        <span className="u_mr-5"><Icon.Location size={14} fill={COLOR.u_icon_bg}/></span>
                                        <p className="u_font">{_ALL[props?.editData?.candidate?.location] ?? '-'}</p>
                                    </div>
                                    <div className="u_flex-align u_pl-10">
                                        <span className="u_mr-5"><Icon.Contact size={14} fill={COLOR.u_icon_bg}/></span>
                                        <p className="u_font">{props?.editData?.candidate?.contactNo || '-'}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="u_px-15 u_br-light">
                                <UNameJobInfo
                                    name={getLabel(PROFILE_SECTION.jobInfo, 'jobTitle', 'Job Title')}
                                    job={_A_JTL[props?.editData?.candidate?.jobTitle] ?? '-'}
                                />
                            </div>
                            {props?.editData?._id && <div className="u_pl-15">
                                <UNameJobInfo
                                    name="Status"
                                    job={!!getStatus ? <UTags className="u_ib" title={getStatus?.label} color={getStatus?.color}/> : '-'}
                                />
                            </div>}
                        </div>}

                        <div className="u_row">
                            {!props?.editData && <div className="u_col-6 u_mb-20">
                                <UInput label="Candidate" select asterisk selectValue={allValues?.candidate}
                                        hasError={validator.current.message('candidate', allValues?.candidate, 'required')}>
                                    <AsyncEmployeeSelect
                                        value={allValues?.candidate}
                                        onChange={(e) => handle?.change(e, 'candidate')}
                                        params={{menuPlacement: 'auto'}}
                                        candidate={true}
                                        requestData={{type: 'interview'}}
                                    />
                                </UInput>
                            </div>}
                            <div className="u_col-6 u_mb-20">
                                <UInput label="Interview Type" asterisk select selectValue={getKeyName(_ITL, allValues?.interviewType) ?? null}
                                        hasError={validator.current.message('interviewType', allValues?.interviewType, 'required')}>
                                    <Select
                                        name="type"
                                        className="u_input-select-inner"
                                        classNamePrefix="u_select"
                                        placeholder=" "
                                        value={getKeyName(_ITL, allValues?.interviewType) ?? null}
                                        onChange={(e) => handle?.change(e?.value, 'interviewType')}
                                        options={_ITL}
                                    />
                                </UInput>
                            </div>
                            <div className="u_col-6 u_mb-20">
                                <UInput label="Select Stage" asterisk select selectValue={getKeyName(stageList, allValues?.interviewStage) ?? null}
                                        hasError={validator.current.message('interviewStage', allValues?.interviewStage, 'required')}>
                                    <Select
                                        name="interviewStage"
                                        className="u_input-select-inner"
                                        classNamePrefix="u_select"
                                        placeholder=" "
                                        value={getKeyName(stageList, allValues?.interviewStage) ?? null}
                                        onChange={(e) => handle?.change(e?.value, 'interviewStage')}
                                        options={stageList}
                                        components={{
                                            Option: (props) => (
                                                <components.Option {...props}>
                                                    <div className={`u_flex u_align-center u_flex-wrap ${props.data.parent ? "u_pl-15" : "u_pl-0 u_text-bold"
                                                        }`} >
                                                        <span className="u_one-line u_mr-5">{props.data.label}</span>
                                                    </div>
                                                </components.Option>
                                            ),
                                            SingleValue: (props) => (
                                                <components.SingleValue {...props}>
                                                    <div className="u_flex u_align-center">
                                                        <span>{props.data.label}</span>
                                                    </div>
                                                </components.SingleValue>
                                            ),
                                        }}
                                    />
                                </UInput>
                            </div>
                            <div className="u_col-6 u_mb-20">
                                <UInput label={`${getLabel(PROFILE_SECTION.basicInfo, 'companyId', 'Company')} ${getLabel(PROFILE_SECTION.jobInfo, 'location', 'Location')}`} select selectValue={allValues?.location}
                                        asterisk={isOnSiteInterview}
                                        hasError={isOnSiteInterview ? validator.current.message('location', allValues?.location, 'required') : null}>
                                    <Select
                                        name="location"
                                        className="u_label-input-select-inner"
                                        classNamePrefix="u_select"
                                        placeholder=" "
                                        value={getKeyName(_A_LT, allValues?.location) ?? null}
                                        onChange={e => handle.change(e?.value, 'location')}
                                        options={_A_LT?.filter((_ => _.isActive && !_.isDeleted))}
                                        noOptionsMessage={() => 'No location found'}
                                        menuPosition="fixed"
                                        maxMenuHeight={150}
                                        onKeyDown={e => {
                                            if ((e.keyCode === 32 || e.keyCode === 8 || e.keyCode === 9) && !e.target.value) e.preventDefault();
                                        }}
                                    />
                                </UInput>
                            </div>
                        </div>

                        {getKeyName(_ITL, allValues?.interviewType)?.label === 'Zoom' && <div className="u_row">
                                <div className="u_col-12 u_mb-20">
                                    {loading ? <Skeleton width='100%' height='50px' /> : <UInput label="Zoom Event Host" asterisk select selectValue={allValues?.zoomHostEmail}
                                             hasError={validator.current.message('zoomHostEmail', allValues?.zoomHostEmail, 'required')}>
                                        <Select
                                            name="type"
                                            className="u_input-select-inner"
                                            classNamePrefix="u_select"
                                            placeholder=" "
                                            value={allValues?.zoomHostEmail}
                                            onChange={(e) => handle?.change(e, 'zoomHostEmail')}
                                            options={zoomUser}
                                        />
                                    </UInput>}
                                </div>
                            </div>
                        }

                        <div className="u_row">
                            <div className="u_col-6 u_mb-20">
                                <UInput label={'Select Date'} datepicker selectDate={allValues?.date}
                                        hasError={validator.current.message('date', allValues?.date, 'required')}
                                        className="u_datetime-picker">
                                    <UDatePicker
                                        dateFormat="dd/MM/yy h:mm aa"
                                        timeIntervals={10}
                                        name="date"
                                        onChange={(e) => handle?.change(e, 'date')}
                                        selected={allValues?.date ? new Date(allValues?.date) : null}
                                        placeholderText=" "
                                        popperPlacement="bottom-start"
                                        showTimeSelect
                                    />
                                </UInput>
                            </div>
                            <div className="u_col-6 u_mb-20">
                                <UInput hoursMinutes label="Total Duration" asterisk
                                        hasError={validator.current.message('duration', (allValues?.duration), 'required|numeric|min:1,num')}>
                                    <UHoursMinutes
                                        grid
                                        value={allValues?.duration}
                                        onChange={e => handle.change(e, 'duration')}
                                    />
                                </UInput>
                            </div>
                            <div className="u_col-12 u_mb-5">
                                <div className={`u_interview-editor-container`}>
                                    <UInput label={''}
                                            hasError={validator.current.message('rawText', (allValues?.rawText), 'max:500,string')}>
                                        <UDraftEditor
                                            fontSelect
                                            ref={editorRef}
                                            maxFiles={-1}
                                            height={200}
                                            className="u_interview-editor"
                                            textLimit={2500}
                                            isDisabled={false}
                                            placeholder={'Add a note'}
                                            value={allValues?.note}
                                            onChange={handle?.handleEditorChange}
                                        />
                                    </UInput>
                                </div>
                            </div>
                            <p className="u_font u_fs-italic u_pl-10 u_mb-20">*This note will visible to the candidate*</p>
                            <div className="u_col-12 u_mb-20 u_flex u_align-center">
                                <UCheckBox
                                    id={`info`}
                                    label="Wanted to attach candidate basic information or not?"
                                    name="info"
                                    className="u_mr-5 u_ib u_cp"
                                    htmlFor="info"
                                    checked={allValues?.isCandidateInfoAttached}
                                    onChange={(e) => handle?.change(e?.target.checked, 'isCandidateInfoAttached')}
                                />
                                {/*<span className="u_cp u_flex"><Icon.Details size={16} fill={COLOR.u_icon_bg}/></span>*/}
                            </div>
                            {allValues?.isCandidateInfoAttached && <React.Fragment>
                                <div className="u_col-6 u_mb-20 u_disabled">
                                    <UInput label="Contact Number" hasError={false}>
                                        <input readOnly name="contactNo" placeholder=" "
                                               value={allValues?.candidate?.contactNo ?? null}/>
                                    </UInput>
                                </div>
                                <div className="u_col-6 u_mb-20 u_disabled">
                                    <UInput label={getLabel(PROFILE_SECTION.emergencyContact, 'email', 'Email')} hasError={false}>
                                        <input readOnly name="email" placeholder=" "
                                               value={allValues?.candidate?.email ?? null}/>
                                    </UInput>
                                </div>
                            </React.Fragment>}
                        </div>
                        <div className="u_row u_align-center">
                            <div className="u_col-6 u_mb-20">
                                <p className="u_small-font u_task-darkname">Candidate & Interviewer reminder before start the interview</p>
                            </div>
                            <div className="u_col-2 u_mb-20">
                                <UInput hasError={validator.current.message('remindBefore', allValues?.remindBefore, 'required')}>
                                    <input type="number" name="remindBefore" placeholder=" " value={allValues?.remindBefore}
                                           onKeyDown={e => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                                           autoComplete="off" onChange={e => handle.change(e?.target?.value, 'remindBefore')}/>
                                </UInput>
                            </div>
                            <div className="u_col-4 u_mb-20">
                                <Select
                                    name="type"
                                    className="u_input-select-inner"
                                    classNamePrefix="u_select"
                                    placeholder=" "
                                    value={getKeyName(REMINDER.INTERVAL_TYPE, allValues?.reminderType) ?? null}
                                    onChange={(e) => handle?.change(e?.value, 'reminderType')}
                                    options={REMINDER.INTERVAL_TYPE}
                                />
                            </div>
                        </div>

                        <div className="u_mb-15 u_flex-align">
                            <UCheckBox
                                id='isSendEmail'
                                label={`Send ${getLabel(PROFILE_SECTION.emergencyContact, 'email', 'Email')}`}
                                checked={allValues?.isSendEmail}
                                onChange={(e) => handle.change(e?.target?.checked, 'isSendEmail')}
                            />

                            <UPopup
                                params={{className: "u_tooltip"}}
                                desc={<span>Along with this you also need permission in Setting >> Notification >> Interview Schedule >> {getLabel(PROFILE_SECTION.emergencyContact, 'email', 'Email')} >> only then the user will receive the mail of the interview.</span>}
                            >
                                <span className="u_cp u_flex u_ml-10"><Icon.InfoTooltip fill={COLOR.u_icon_bg} size={16}/></span>
                            </UPopup>
                        </div>

                        <div className="u_mb-10 u_flex u_align-center">
                            <h6 className="u_small-font u_pr-10">Interviewer</h6>
                        </div>
                        <div className="u_flex u_align-center u_flex-wrap u_mb-10">
                            {allValues?.interviewer?.length !== 0 && <div className="u_mr-12 u_flex u_align-center u_flex-wrap">
                                {allValues?.interviewer.map((data, i) => {
                                    return (<div className="u_mr-5 u_relative u_hiring-team-avatar" key={i}>
                                        <div>
                                            <UAvatar name={_USERS[data]?.name} width={22} thumbor={getThumbor('32x32')}
                                                     image={_USERS[data]?.profileImage} s3Url={_S3_BASE_URL}/>
                                            <div className="u_hiring-team-remove u_cp u_ml-10" onClick={() => handle.remove(data, 'interviewer')}>
                                                <Icon.Close fill={COLOR.u_white} size={6} className="u_flex"/>
                                            </div>
                                        </div>
                                    </div>)
                                })}
                            </div>}
                            <div className="u_hiring-team-inner">
                                <Popup
                                    ref={popupRef}
                                    trigger={_o => (
                                        <div className={`u_btn-hover u_flex u_align-center u_cp ${_o ? 'u_active' : ''}`}>
                                            <div className="u_plus-follower"><Icon.Plus fill={COLOR.u_font} size={12}/></div>
                                            <p className="u_pl-5 u_small-font">Add Interviewer</p>
                                        </div>
                                    )}
                                    className="u_moremenu"
                                    position="bottom left"
                                    closeOnDocumentClick
                                    repositionOnResize
                                    keepTooltipInside={true}
                                    overlayStyle={{zIndex: 100004}}
                                    arrow={false}
                                    menuPlacement={'auto'}
                                    menuPosition="fixed"
                                    offsetY={-30}
                                    offsetX={80}
                                >
                                    <Select
                                        name="interviewer"
                                        className="u_label-input-select-inner u_mr-15"
                                        classNamePrefix="u_select"
                                        placeholder="Select Interviewer"
                                        value={null}
                                        menuIsOpen={true}
                                        onInputChange={handle.search}
                                        onChange={e => handle.select(e, 'interviewer')}
                                        options={employeeListOption.filter(a => allValues?.interviewer?.every(b => a?.value !== b))}
                                        noOptionsMessage={() => search?.length < 3 ? 'Type three character to search interviewer.' : isLoading ? 'Loading...' : 'No Record Found'}
                                        menuPosition="fixed"
                                        onKeyDown={e => {
                                            if ((e.keyCode === 32 || e.keyCode === 8 || e.keyCode === 9) && !e.target.value) e.preventDefault();
                                        }}
                                        components={{
                                            Option: (props) => (
                                                <components.Option {...props}>
                                                    <div className="u_filter-employee-info">
                                                        <UAvatar name={props?.data?.label} width={24} thumbor={getThumbor('32x32')}
                                                                 image={props?.data?.profileImage} s3Url={_S3_BASE_URL}/>
                                                        <p className="u_one-line">{props?.data?.label}</p>
                                                    </div>
                                                </components.Option>
                                            ),
                                            SingleValue: (props) => (
                                                <components.SingleValue {...props}>
                                                    <div className="u_filter-employee-info">
                                                        <UAvatar name={props?.data?.label} width={24} thumbor={getThumbor('32x32')}
                                                                 image={props?.data?.profileImage} s3Url={_S3_BASE_URL}/>
                                                        <p className="u_one-line">{props?.data?.label}</p>
                                                    </div>
                                                </components.SingleValue>
                                            ),
                                        }}
                                    />
                                </Popup>
                            </div>
                        </div>

                        {(P_E?.create || allValues?.evalution?.length !== 0) && <div className="u_flex-align u_mb-10">
                            <h6 className="u_title_heading">Evaluation</h6>
                        </div>}
                        {P_E?.create && <div className="u_add-request u_mb-15" onClick={() => setRequestData({requestFrom: allValues?.interviewer})}>
                            <p className="u_flex-align">
                                <span className="u_mr-8 u_cp u_flex"><Icon.Plus size={10} fill={COLOR.u_icon_bg}/></span>
                                Request evaluation</p>
                        </div>}
                        {allValues?.evalution?.map((data, i) => {
                            return <div className="u_evaluation-list" key={i}>
                                <p>{screeningQuestionsList?.find(e => e.value === data?.evaluationForm)?.label}</p>
                                <div className="u_flex-align">
                                    <div className="u_mr-20"><MembersList members={data?.requestFrom}/></div>
                                    {(P_E?.update || P_E?.delete) && !data?._id && <div className="u_pl-10 u_bl-light">
                                        <UPopup
                                            params={{ref: popupRef, position: "bottom right", contentStyle: {zIndex: 1111111},}}
                                            desc={
                                                <ul className="u_menu_list">
                                                    {P_E?.update && <li onClick={() => handle.editEvaluation(data, i)}><Icon.Edit fill={COLOR?.u_icon_bg} size={14} className="u_mr-10"/>Edit</li>}
                                                    {P_E?.delete && <li onClick={() => handle.removeEvaluation(i)}><Icon.Delete fill={COLOR?.u_icon_bg} size={14} className="u_mr-10"/>Delete</li>}
                                                </ul>
                                            }
                                        >
                                            <span className={`u_cp`}>
                                                <Icon.HorizontalMenu size={20} fill={COLOR.u_icon_bg}/>
                                            </span>
                                        </UPopup>
                                    </div>}
                                </div>
                            </div>
                        })}

                        <div className="u_flex-align u_mb-10">
                            <h6 className="u_title_heading">Questionnaire</h6>
                        </div>
                        <div className="u_col-4 u_mb-20">
                            <UInput label="Questionnaire Template" select selectValue={getKeyName(questionnaireList, allValues?.questionnairyId) ?? null}
                                    hasError={false}>
                                <Select
                                    name="questionnairyId"
                                    className="u_input-select-inner"
                                    classNamePrefix="u_select"
                                    placeholder=" "
                                    menuPosition="fixed"
                                    value={getKeyName(questionnaireList, allValues?.questionnairyId) ?? null}
                                    onChange={(e) => handle?.change(e?._id, 'questionnairyId')}
                                    options={questionnaireList}
                                    isClearable={true}
                                />
                            </UInput>
                        </div>
                        {isRescheduleAttempt && (
                            <React.Fragment>
                                <div className="u_flex-align u_mb-10  u_title_heading">
                                    <h6>Rescheduled Reason</h6><p className="u_color-red">*</p>
                                </div>
                                <div className="u_mb-20">
                                    <UInput asterisk textarea
                                            hasError={validator.current.message('currentRescheduleNote', allValues.currentRescheduleNote, 'required')}>
                                        <textarea
                                            className={`u_textarea`}
                                            name="currentRescheduleNote"
                                            placeholder="Add reason for rescheduling..."
                                            value={allValues.currentRescheduleNote}
                                            onChange={(e) => handle.CurrentRescheduleNote(e.target.value)}
                                            maxLength={500}
                                        />
                                    </UInput>
                                </div>
                            </React.Fragment>
                        )}

                    </div>
                </div>
                <div className="u_modal-buttons">
                    <UButton disabled={loader} loading={loader} variant="white" type="Cancel" onClick={(e) => props.close()}/>
                    <UButton disabled={loader} loading={loader} isSubmit variant="blue" type="Save" cn="u_ml-10" onClick={handleInterviewFormPopup}/>
                </div>
            </UModal>

            {isApplyPopup && <InterviewFormPopup
                open={isApplyPopup}
                title={
                    <div className="u_flex u_align-center">
                        <span className="u_mr-10">Send Interview Form</span>
                        <UTooltip
                            text={
                                <div>Candidate can submit the Interview Form only once. Once the form is submitted, the link will not accept another submission even if you send the link again.</div>
                            }
                            on={open => (<div className="u_cp u_flex"><Icon.Details size={16} fill={COLOR.u_icon_bg}/></div>)}
                        />
                    </div>
                }
                description="Choose how you would like to send the form."
                radioOptions={[
                    {
                        id: "sendNow",
                        label: "Send Now",
                        text: `The form will be sent to the candidate immediately via ${getLabel(PROFILE_SECTION.emergencyContact, 'email', 'Email')} for their quick review and response.`,
                        value: true
                    },
                    {
                        id: "sendLater",
                        label: "Send later",
                        text: "The form will not be sent right now, but you can easily send it later when required.",
                        value: false
                    }
                ]}
                selectedValue={allValues.isSendInterviewForm}
                onChange={(value) => handle.change(value, "isSendInterviewForm")}
                showLinkBox={allValues.isSendInterviewForm === false}
                linkValue={applyInterviewURL}
                onClose={() => setIsApplyPopup(null)}
                onSubmit={() => handle.scheduleInterview()}
                loading={loader}
            />}

            {!!requestData && <RequestEvaluation
                addEvaluation={handle.addEvaluation}
                requestData={requestData}
                screeningQuestionsList={screeningQuestionsList}
                close={() => setRequestData(null)}
            />}
        </React.Fragment>
    );
});

export default AddInterview;